export default __webpack_public_path__ + "static/media/sr-100.bd644019.mp3";